import { render, staticRenderFns } from "./homeView.vue?vue&type=template&id=8674bd3a"
import script from "./homeView.vue?vue&type=script&lang=js"
export * from "./homeView.vue?vue&type=script&lang=js"
import style0 from "./homeView.vue?vue&type=style&index=0&id=8674bd3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports